import $ from 'jquery';
import Actions from '@ppcp/actions';

const actions = new Actions();
actions.addFilter('add_to_cart_data', (data, cart) => {
    const extraData = $('form.cart .tmcp-field').serializeArray().reduce((carry, obj) => {
        return {...carry, [obj.name]: obj.value};
    }, {});
    return {...data, ...extraData};
});